import { render } from "./UpdatesBlock.vue?vue&type=template&id=efcab942"
import script from "./UpdatesBlock.vue?vue&type=script&lang=js"
export * from "./UpdatesBlock.vue?vue&type=script&lang=js"

import "./UpdatesBlock.vue?vue&type=style&index=0&id=efcab942&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__